import {TrackingConstants} from 'app/shared/services/tracking/tracking-constants.service';
import {MessageService} from './../../../../services/messages.service';
import {TrackingService} from './../../../../shared/services/tracking/google-analytics-events.service';
import {SnackBarService} from 'app/services/snackbar.service';
import {Component} from '@angular/core';
import {
  EntityRelationsService,
  RelationshipPanelActions
} from 'app/entities/relations/entity-relations.service';
import {MdDialogRef} from '@angular/material';

@Component({
  moduleId: module.id,
  selector: 'app-confirmdeleterelationship',
  templateUrl: 'confirmdeleterelationship.component.html',
  styleUrls: ['confirmdeleterelationship.component.css']
})
export class ConfirmDeleteRelationshipComponent {
  relationshipId: any;

  constructor(public dialogRef: MdDialogRef<any>,
              private trackingService: TrackingService,
              private snackBarService: SnackBarService,
              private entityRelationsService: EntityRelationsService,) {
  }

  delete() {
    this.entityRelationsService.deleteRelation(this.relationshipId).subscribe(
      success => {
        if (success) {
          this.entityRelationsService.sendMessage(RelationshipPanelActions.UPDATE_RELATIONSHIPS.toString());
          this.trackingService
            .emitEvent(TrackingConstants.RELATIONSHIP, TrackingConstants.DELETE_RELATIONSHIP, TrackingConstants.SUCCESS, 1);
        }
        this.dialogRef.close(success);
        this.callSnackBarService(success);
      },
      err => {
        this.dialogRef.close(false);
        this.callSnackBarService(err);
        this.trackingService
          .emitEvent(TrackingConstants.RELATIONSHIP, TrackingConstants.DELETE_RELATIONSHIP, TrackingConstants.FAILURE, 0);
      }
    );
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
        MessageService.DELETE_RELATION_SUCCESS,
        MessageService.DELETE_RELATION_FAILURE);
  }

}




// WEBPACK FOOTER //
// ./src/app/entities/relations/relationship/confirmdeleterelationship/confirmdeleterelationship.component.ts